<app-header></app-header>
<main [class.channelActive]="isChannelVisible">
    <app-menue @slideInUpSlow *ngIf="isMenuVisible"></app-menue>
    <app-channel @slideInLeftSlow *ngIf="isChannelVisible"></app-channel>
</main> 